<template>
  <modal name="add-cpvs-to-tender-modal"
         @before-close="resetComponent"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Ընտրել Չափաբաժիններ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('add-cpvs-to-tender-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 90%">
      <div class="row mb-3">
        <div class="col-12">
          <div class="w-100 border rounded p-3 shadow">
            <div class="form-row">
              <div class="col-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <font-awesome-icon icon="search" />
                    </span>
                  </div>
                  <input @input="search" 
                      :value="searchQuery"
                      placeholder="Փնտրիր ըստ անվան կամ կոդի" 
                      name="searchQuery" 
                      type="text" 
                      class="form-control">
                </div>
              </div>
              <div class="col-3">
                <div
                  v-tooltip="selectedType
                  ?
                    'մեկ ընթացակարգում չի կարող լինել տարբեր գնման ձևերով չափաբաժին'
                  :
                    ''
                  "
                  class="input-group"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text">Գնման ձև</span>
                  </div>
                  <select @change="filterCpvs" 
                      :disabled="selectedType"
                      v-tooltip="selectedType ? 'մեկ ընթացակարգում չի կարող լինել տարբեր գնման ձևերով չափաբաժին' :''"
                      :value="selectedType?selectedType:purchaseType" 
                      name="purchaseType" 
                      class="form-control" 
                      id="purchase-type">
                      <option v-for="(type, key) in purchaseTypesForCompetetive" 
                      :key="key" 
                      :value="key">{{ type }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-5">
          <div class="w-100 border rounded shadow p-3" style="height: 55vh; overflow-y: auto;">
            <h4>Գնման առարկաներ (պլան {{currentPlan ? currentPlan.year : ''}})</h4>
            <div v-for="cpv in cpvsFromPlan" 
                :key="cpv.id" 
                class="custom-control custom-checkbox my-1">
              <input v-model="selectedCpvs"
                      @change="(event)=>handleSelect(event, cpv)"
                      :value="cpv"
                      :disabled="getRealBalance(cpv) < 1
                       || selectedLots.find(item=>item.cpv_code===cpv.cpv_code)
                       || selectedIsCondition !== false && selectedIsCondition !== cpv.is_condition"
                      type="checkbox"
                      class="custom-control-input"
                      :id="cpv.id">
              <label 
              v-tooltip="
                getRealBalance(cpv) < 1 ? 'մնացորդ 0'
              :
                selectedLots.find(item=>item.cpv_code === cpv.cpv_code) ? 'արդեն ընտրված է'
              :
                selectedIsCondition !== false && selectedIsCondition != cpv.is_condition ? 'մեկ ընթացակարգում չի կարող լինել պայմանով և առանց պայմանի չափաբաժին'
              :
              ''
              "
                     class="custom-control-label" :for="cpv.id">
                {{ cpv.cpv_code }}{{ cpv.cpv_drop !== null ? '/' : ''}}{{ cpv.cpv_drop }} - {{ cpv.cpv_name }}
              </label>
            </div>
            <infinite-loading @infinite="infiniteHandler">
              <div slot="no-results"></div>
              <div slot="no-more"></div>
            </infinite-loading>
          </div>
        </div>
        <div class="col-7" style="height: 55vh; overflow-y: auto;">
          <div v-for="cpv in selectedCpvs"
              :key="cpv.id"
              class="row border rounded py-2 mx-0 shadow mb-2">
            <div class="col">
              <span>{{ cpv.cpv_code }}{{ lot.cpv_drop && '/' }}{{ cpv.cpv_drop }} - {{ cpv.cpv_name }}</span>
            </div>
            <div class="col">
              <span class="mr-3">Մնացորդ</span>
              <span>{{ getCurrentBalance(cpv) }}</span>
            </div>
            <div class="col">
              <span>կազմակերպվող քանակ</span>
              <input v-model.number="cpv.organizing_count"
                     @input="setOverallValidationError(cpv)"
                     class="form-control"
                     min="1"
                     :max="cpv.count - cpv.out_count - cpv.organize_count"
                     type="number">
              <span class="small text-danger"
                    v-if="cpv.organizing_count > getRealBalance(cpv)">չի կարող մեծ լինել մնացորդից</span>
              <span class="small text-danger" v-if="cpv.organizing_count <= 0">պետք է լինի մեծ 0-ից</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('add-cpvs-to-tender-modal')" class="btn btn-sm btn-light mr-3">
        Չեղարկել
      </button>
      <button @click="addOrganizeRows" type="button" class="btn btn-sm btn-primary">
        Ավելացնել
      </button>
    </div>
    <!-- <specification-modal @close="setSpecificationId"/> -->
  </modal>
</template>

<script>
  // import CpvSearch from '../../../../components/dashboard/cpv/CpvSearch'
  import purchaseTypesForCompetetive from '@/mixins/purchaseTypes'
  import InfiniteLoading from 'vue-infinite-loading'
  import { required, between } from 'vuelidate/lib/validators'

  // import SpecificationModal from './SpecificationModal'


  export default {
    name: 'AddCpvsToTenderModal',
    mixins: [purchaseTypesForCompetetive],
    props: ['insertLotFromOutside'],
    components: { InfiniteLoading },
    computed: {
      // combinedCpvs() {
      //   // eslint-disable-next-line no-undef
      //   return _.unionWith(this.selectedCpvs, this.searchedCpvs, _.isEqual)
      // },
      // units() {
      //   return this.$store.getters['settings/units']
      // },
      // financialClassifiers() {
      //   return this.$store.getters['settings/financialClassifiers']
      // },
      // classifiers() {
      //   return this.$store.getters['settings/classifiers']
      // },
      // childUsers() {
      //   return this.$store.getters['user/userChildren']
      // },
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      }
    },
    data() {
      return this.getModalInitialState()
    },
    methods: {
      consoleLog(e){
        console.log(e)
      },
      handleSelect(event, cpv) {
        if(event.target.checked){
          this.selectedIsCondition = cpv.is_condition;
        } else if(this.selectedCpvs.length===0){
          this.selectedIsCondition = false;
        }
      },
      getModalInitialState() {
        return {
          selectedLots: [],
          selectedType: false,
          selectedIsCondition: false,
          isOnePerson: false,
          pagination: {},
          searchQuery: '',
          cpvType: 1,
          purchaseType: 3,
          searchTimeout: null,
          selectedCpvs: [],
          cpvsFromPlan: [],
          overallValidationError: false,
        }
      },
      setOverallValidationError(cpv) {
        const realBalance = this.getRealBalance(cpv)
        this.overallValidationError = !cpv.organizing_count || realBalance < 1 || cpv.organizing_count > realBalance
      },
      search(event) {
        if(this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.filterCpvs(event)
        }, 700)
      },
      beforeOpen(event) {
        this.cpvType = this.$route.query.cpvType
        if(event.params.length){
          this.selectedLots = event.params
          this.selectedType = event.params[0].type
          this.selectedIsCondition = event.params[0].is_condition
        }
      },
      filterCpvs({target: {name, value}}) {
        this[name] = value
        this.pagination = {}
        this.selectedCpvs = []
        this.cpvsFromPlan = []
        this.getCpvsRequest().then(({data: {data}}) => {
          console.log('filterCpvs')
          this.cpvsFromPlan = data.map(cpv => Object.assign(cpv, {organizing_count: 1}))
          console.log(this.cpvsFromPlan)
        })        
      },
      getCpvsRequest() {
        console.log('getCpvsRequest')
        return this.$client.get(`procurement-plan/getByQuery/${this.currentPlan.id}`, {
          params: {
            cpv_type: this.cpvType,
            type: this.selectedType?this.selectedType:this.purchaseType,
            query: this.searchQuery,
            page: this.pagination.page ? (this.pagination.page + 1) : 1
          }
        })
      },
      infiniteHandler($state) {
        this.getCpvsRequest().then(({data: {data, pagination}}) => {
          if(data.length) {
            this.pagination = pagination;
            this.cpvsFromPlan.push(...data.map(cpv => Object.assign(cpv, {organizing_count: 1})));
            $state.complete();
          }else{
            $state.complete();
          }
        });
      },
      addOrganizeRows() {
        if(this.selectedCpvs.length && !this.overallValidationError) {
          this.$client.post('organize-row-array', {
            organize_row: this.selectedCpvs.map(cpv => ({
              plan_details_id: cpv.id,
              count: cpv.organizing_count,
              procurement_plan_id: cpv.plan_row_id,
              organize_id: this.currentOrganized.id,
            }))
          }).then(({ data }) => {
            if(data.status) {
              this.$store.dispatch('organize/getRows', {organizeId: this.currentOrganized.id})
              this.$store.dispatch('organizeOnePerson/getRows', {organizeId: this.$route.params.id})
              this.$modal.hide('add-cpvs-to-tender-modal')
            }
          })
        }
      },
      getRealBalance(cpv) {
        return cpv.count - cpv.out_count - cpv.organize_count
      },
      getCurrentBalance(cpv) {
        return cpv.count - cpv.out_count - cpv.organizing_count - cpv.organize_count
      },
      resetComponent() {
        Object.assign(this.$data, this.getModalInitialState())
      },
    },
    validations() {
      return {
        selectedCpvs: {
          $each: {
            id: {},
            cpv_code: {},
            cpv_drop: {},
            cpv_name: {},
            count: {},
            out_count: {},
            organize_count: {},
            organizing_count: {
              required,
              between: between(20, 30)
            },
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
